import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import ServiceLocationList, { DispatchProps, OwnProps, StateProps } from './ServiceLocationListScreen';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getServiceLocations } from 'src/store/actions/service-location-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.serviceLocations.data,
        inProgress: state.serviceLocations.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getServiceLocations(params)),
    };
}

const ServiceLocationListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ServiceLocationList);

export default ServiceLocationListScreen;
